import { textDecoration } from "@chakra-ui/react";

export default {
    baseStyle: {
        footer: {
            padding: {base: '12px 24px'},
            pb: {base: '92px', lg: '12px'},
            borderTop: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            mt: {lg: 8}
        },
        content: {
            direction: {base: 'column', lg: 'row'},
            justifyContent: 'space-between',
            alignItems: {base: 'flex-start', lg: 'center'},
            gap: {base: 5, lg: 6}
        },
        contentWrapper: {
            gap: {base: 2},
            flexWrap: 'no-wrap'
        },
        secureLock: {
            width: 4,
            height: 4
        },
        contentText: {
            textStyle: 'bodyXsRegular'
        },
        privacyLink: {
            textDecoration: 'underline'
        },
        copyrightText: {
            textStyle: 'bodyXsRegular',
            flex: {lg: '0 0 auto'}
        }
    }
}
